<div class="overlay spinner-container column">
  <mat-spinner class="spinner" [diameter]="60"></mat-spinner>
  <p class="loader-text">{{ "SHARED.GLOBAL_LOADER.TEXT" | translate }}</p>
</div>
